import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { CalculationLogPage, IStateProps } from './CalculationLogPage'
import { RootState } from '../../reducers/root-reducer'
import { CalculationLogRouteProps } from '../Router/Router'
import { loadCalculationLog } from './actions/LoadCalculationLog'

const mapStateToProps = (_: RootState, ownProps: CalculationLogRouteProps): IStateProps => {
    return {
        runIdentifier: ownProps.match.params.runIdentifier,
        messageService: ownProps.messageService
    }
}

const mapDispatchToProps = {
  getLogs: (runIdentifier: string) => loadCalculationLog(runIdentifier)
}

export const CalculationLogContainer = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(CalculationLogPage)
)